<template>
  <div class="square-payment-timeout-content">
    <div class="timeout-header">
      <font-awesome-icon
        icon="clock"
        size="3x"
        class="text-warning mb-3"
      />
      <h4 class="mb-3">
        Payment Response Not Received
      </h4>
    </div>

    <div class="timeout-body">
      <p class="timeout-message">
        The payment response from the Square terminal has not been received after {{ elapsedTime }} seconds.
      </p>

      <p class="instruction-message">
        Please select one of the following options:
      </p>

      <div
        v-if="waitingForRetry"
        class="retry-info mb-3"
      >
        <b-spinner
          small
          class="mr-2"
        />
        <span>Waiting for response... ({{ remainingWaitTime }}s remaining)</span>
      </div>

      <div class="action-buttons">
        <b-button
          :disabled="waitingForRetry || processing"
          variant="success"
          size="lg"
          block
          class="mb-2"
          @click="manualConfirm"
        >
          <font-awesome-icon
            icon="check-circle"
            class="mr-2"
          />
          Manually Confirm Payment
        </b-button>
        <p class="small text-muted mb-3 text-center">
          Use this option only if you can verify the payment was successful on the terminal
        </p>

        <b-button
          :disabled="waitingForRetry || processing"
          variant="primary"
          size="lg"
          block
          class="mb-2"
          @click="continueWaiting"
        >
          <font-awesome-icon
            icon="hourglass-half"
            class="mr-2"
          />
          Continue Waiting ({{ nextWaitDuration }}s more)
        </b-button>
        <p class="small text-muted mb-3 text-center">
          The system will wait for another {{ nextWaitDuration }} seconds for the terminal response
        </p>

        <b-button
          :disabled="waitingForRetry || processing"
          variant="danger"
          size="lg"
          block
          @click="cancelPayment"
        >
          <font-awesome-icon
            icon="times-circle"
            class="mr-2"
          />
          Cancel Payment Processing
        </b-button>
        <p class="small text-muted text-center">
          Cancel the payment and inform that it needs to be restarted
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'square-payment-timeout-content',
  props: {
    elapsedTime: {
      type: Number,
      required: false,
      default: 30
    },
    nextWaitDuration: {
      type: Number,
      required: false,
      default: 30
    }
  },
  data() {
    return {
      processing: false,
      waitingForRetry: false,
      remainingWaitTime: this.nextWaitDuration,
      countdownInterval: null
    }
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  },
  methods: {
    manualConfirm() {
      this.processing = true
      this.$emit('manual-confirm')
    },
    continueWaiting() {
      this.waitingForRetry = true
      this.remainingWaitTime = this.nextWaitDuration

      // Start countdown
      this.countdownInterval = setInterval(() => {
        this.remainingWaitTime--
        if (this.remainingWaitTime <= 0) {
          clearInterval(this.countdownInterval)
          this.waitingForRetry = false
        }
      }, 1000)

      this.$emit('continue-waiting', {
        duration: this.nextWaitDuration,
        stopCountdown: () => {
          if (this.countdownInterval) {
            clearInterval(this.countdownInterval)
          }
          this.waitingForRetry = false
        }
      })
    },
    cancelPayment() {
      this.processing = true
      this.$emit('cancel-payment')
    }
  }
}
</script>

<style scoped>
.square-payment-timeout-content {
  text-align: center;
  padding: 1rem;
}

.timeout-header {
  margin-bottom: 1.5rem;
}

.timeout-message {
  font-size: 1.1rem;
  margin-bottom: 1rem;
}

.instruction-message {
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.retry-info {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
  font-weight: 500;
}

.action-buttons {
  margin-top: 1rem;
}

.action-buttons .small {
  font-size: 0.875rem;
  margin-top: -0.5rem;
}
</style>
